document.addEventListener("DOMContentLoaded", () => {
  const openBtn = document.getElementById("openModalBtn");
  const closeBtn = document.getElementById("closeModalBtn");
  const overlay = document.getElementById("modalOverlay");
  const form = document.getElementById("waitlistForm");
  const successState = document.getElementById("successState");

  const openModal = () => {
    overlay.classList.add("open");
    document.body.style.overflow = "hidden";
    setTimeout(() => document.getElementById("email").focus(), 300);
  };

  const closeModal = () => {
    overlay.classList.remove("open");
    document.body.style.overflow = "";
    // Reset form state after the close transition finishes
    setTimeout(() => {
      form.reset();
      form.classList.remove("hide");
      successState.classList.remove("show");
    }, 300);
  };

  openBtn.addEventListener("click", openModal);
  closeBtn.addEventListener("click", closeModal);

  // Close when clicking the dimmed backdrop (not the modal itself)
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeModal();
  });

  // Close on Escape
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.classList.contains("open")) {
      closeModal();
    }
  });

  // ─────────────────────────────────────────────────────────
  // FORMSPREE SETUP (sends every signup to your inbox)
  // 1. Go to https://formspree.io and sign up (free)
  // 2. Create a new form, set its destination email to:
  //    Sabyasachirajak0@gmail.com
  // 3. Copy the endpoint it gives you, e.g:
  //    https://formspree.io/f/abcdwxyz
  // 4. Paste it below, replacing YOUR_FORM_ID
  // ─────────────────────────────────────────────────────────
  const FORMSPREE_ENDPOINT = "https://formspree.io/f/xaewypjz";
  const endpointConfigured = true;

  const joinBtn = form.querySelector(".join-btn");
  const errorMsg = document.getElementById("formError");

  // Handle submit
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const email = document.getElementById("email").value.trim();
    const phone = document.getElementById("phone").value.trim();

    joinBtn.disabled = true;
    joinBtn.textContent = "JOINING...";
    errorMsg.textContent = "";
    errorMsg.classList.remove("show");

    try {
      if (!endpointConfigured) {
        await new Promise((resolve) => setTimeout(resolve, 700));
        form.classList.add("hide");
        successState.classList.add("show");
        return;
      }

      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error("Submission failed");

      form.classList.add("hide");
      successState.classList.add("show");
    } catch (err) {
      errorMsg.textContent = "Something went wrong. Please try again.";
      errorMsg.classList.add("show");
    } finally {
      joinBtn.disabled = false;
      joinBtn.textContent = "JOIN";
    }
  });
});
